import React from "react";
import BecomeMember from "../components/footer/BecomeMember";
import Footer from "../components/footer/Footer";
import TopbarUser from "../components/topbarUser/TopbarUser";

const LayoutHome = ({ children, becomeMember }) => {
  return (
    <>
      <TopbarUser />
      {children}
      {
        becomeMember != false && <BecomeMember />
      }
      
      <Footer />
    </>
  );
};

export default LayoutHome;
